var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.0625V11.4792",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37901 14.9187C3.55704 16.241 4.65226 17.2769 5.98506 17.3382C7.10654 17.3898 8.24577 17.4167 9.50033 17.4167C10.7549 17.4167 11.8941 17.3898 13.0156 17.3382C14.3484 17.2769 15.4436 16.241 15.6217 14.9187C15.7379 14.0558 15.8337 13.1714 15.8337 12.2708C15.8337 11.3702 15.7379 10.4859 15.6217 9.62295C15.4436 8.30063 14.3484 7.26472 13.0156 7.20345C11.8941 7.15189 10.7549 7.125 9.50033 7.125C8.24577 7.125 7.10654 7.15189 5.98506 7.20345C4.65226 7.26472 3.55704 8.30063 3.37901 9.62295C3.26282 10.4859 3.16699 11.3702 3.16699 12.2708C3.16699 13.1714 3.26282 14.0558 3.37901 14.9187Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9375 7.12498V5.14581C5.9375 3.1783 7.53249 1.58331 9.5 1.58331C11.4675 1.58331 13.0625 3.1783 13.0625 5.14581V7.12498",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordicon);
export default __webpack_public_path__ + "static/media/passwordicon.975afb2fb4de7ac3116632112f137339.svg";
export { ForwardRef as ReactComponent };